// character.ts
import { getContext } from ".";
import { CharacterConfig } from "../types/config";

let idCount: number = 1;
function getUniqueID(): string {
  idCount += 1;
  return String(idCount);
}

const normKey = (s?: string) => String(s ?? "").trim().replace(/\s+/g, "_");

/**
 * Ajoute un personnage avec taille par défaut (50x50).
 * Retourne l'id (string) du personnage créé, ou "-1" si échec.
 */
export const addCharacter = (name: string, x: number, y: number): string => {
  const ctx = getContext();
  const sprite = ctx.sprites.find((item) => item.name === name);
  if (!sprite) return "-1";

  const id = getUniqueID();

  const newChar: CharacterConfig = {
    // Identifiant logique interne — toujours string
    id,

    // Identifiant unique pour Phaser (évite collisions sur même nom)
    idPhaser: `${normKey(name)}_${id}`,

    name,
    x,
    y,
    width: 50,
    height: 50,

    image_url: sprite.image_url,
    animations: sprite.animations,
  };

  ctx.addCharacterCtx(newChar);

  // Immediately sync the character to the engine to avoid timing issues
  // This ensures the character is available for movement functions right away
  try {
    if (ctx.syncCharactersCtx) {
      // Get current characters from context and add the new one
      const currentChars = (globalThis as any).__IDE_BRIDGE__?.characters || [];
      const updatedChars = [...currentChars, newChar];
      ctx.syncCharactersCtx(updatedChars);
    }
  } catch (e) {
    console.warn("[addCharacter] Failed to immediately sync character:", e);
  }

  return newChar.id; // string
};

/**
 * Ajoute un personnage en précisant largeur et hauteur.
 * Retourne l'id (string) du personnage créé, ou "-1" si échec.
 */
export const addCharacterWithSize = (
  name: string,
  x: number,
  y: number,
  width: number,
  height: number
): string => {
  const ctx = getContext();
  const sprite = ctx.sprites.find((s) => s.name === name);
  if (!sprite) return "-1";

  const id = getUniqueID();

  const newChar: CharacterConfig = {
    id,
    idPhaser: `${normKey(name)}_${id}`,
    name,
    x,
    y,
    width,
    height,
    image_url: sprite.image_url,
    animations: sprite.animations,
  };

  ctx.addCharacterCtx(newChar);

  // Immediately sync the character to the engine to avoid timing issues
  try {
    if (ctx.syncCharactersCtx) {
      const currentChars = (globalThis as any).__IDE_BRIDGE__?.characters || [];
      const updatedChars = [...currentChars, newChar];
      ctx.syncCharactersCtx(updatedChars);
    }
  } catch (e) {
    console.warn("[addCharacterWithSize] Failed to immediately sync character:", e);
  }

  return newChar.id; // string
};
